import FQAApplication from "../assets/files/fqa/fqa_application.pdf";
import Hitchcock from "../assets/files/fqa/hitchcock.pdf";
import OpenlandsFQA from "../assets/files/fqa/openlands_fqa.pdf";
import RodgersLandscape from "../assets/files/fqa/rodgers_landscape.pdf";
import Timberhill from "../assets/files/fqa/timberhill.pdf";
import Wilheml from "../assets/files/fqa/wilhelm.pdf";
import Ecosphere from "../assets/files/fqa/Ecosphere.pdf";

interface EssayType {
  name: string;
  file: string;
}

export const FQAEssays: EssayType[] = [
  {
    name: "FQA Application",
    file: FQAApplication,
  },
  {
    name: "Hitchcock",
    file: Hitchcock,
  },
  {
    name: "Openlands FQA",
    file: OpenlandsFQA,
  },
  {
    name: "Rodgers Landscape",
    file: RodgersLandscape,
  },
  {
    name: "Timberhill",
    file: Timberhill,
  },
  {
    name: "Wilhelm",
    file: Wilheml,
  },
  {
    name: "FQA Analysis, Greg Spyreas",
    file: Ecosphere,
  },
];

export default FQAEssays;
export type { EssayType };
